<template>
    <div>
       

        <div class="notification is-warning" v-if="loading == true">
            Loading interviews ...
        </div>

        <div class="notification is-info" v-if="loading == false && interviews.length == 0">
            No interviews found.
        </div>

        <div v-if="loading == false && monthlyInterviewTables.length > 0">
            <div v-for="monthGroup in monthlyInterviewTables" :key="monthGroup.key" class="mb-5">
                <h4 class="title is-size-5 mb-2">{{ monthGroup.label }} ({{ monthGroup.rows.length }})</h4>

                <table class="table is-fullwidth is-hoverable is-size-7" v-if="monthGroup.rows.length > 0">
                    <thead>
                        <tr>
                            <th>Member</th>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Status ID</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in monthGroup.rows" :key="row.id">
                            <td>
                                <router-link v-if="getInterviewMemberId(row)" :to="'/members/' + getInterviewMemberId(row)" target="_blank">{{ getInterviewMemberName(row) }}</router-link>
                                <span v-else>{{ getInterviewMemberName(row) }}</span>
                            </td>
                            <td>{{ row.date }}</td>
                            <td>{{ row.time }}</td>
                            <td>{{ getInterviewStatusLabel(row.status_id) }}</td>
                        </tr>
                    </tbody>
                </table>

                <p v-else>No interviews in this month.</p>
            </div>
        </div>
       
        
       
       
    </div>
</template>

<script>
//import * as XLSX from 'xlsx'

import UtilityService from '@/services/UtilityService.js';
import MemberMixin from '@/mixins/MemberMixin.js';

export default {
    
      name: 'MembersInterviews',
        mixins: [MemberMixin],
        data: function () {
            return {
                member_search: '',
                   interviews: [],
                   loading: false,
                   searchPerformed: false,
                   showModal: false,
                   order_by: 'surname ASC, forename ASC',
                   accessToken: '',
                   include_archived: 0,
                   grades: [],
                   selected_grades: [],
                   working:false
            }
        },
        created() {
            this.getAccessToken()
                .then(() => { 
                    this.getInterviews();
                });
        
        },
        mounted() {
            
        },
        computed: {
            monthlyInterviewTables() {
                if (!Array.isArray(this.interviews) || this.interviews.length === 0) {
                    return [];
                }

                const now = new Date();
                const startMonth = new Date(now.getFullYear(), now.getMonth(), 1);

                const datedInterviews = this.interviews
                    .map(interview => {
                        const parsedDate = this.parseInterviewDate(interview.date);
                        return {
                            ...interview,
                            __parsedDate: parsedDate
                        };
                    })
                    .filter(interview => interview.__parsedDate !== null);

                if (datedInterviews.length === 0) {
                    return [];
                }

                const earliestDate = datedInterviews.reduce((earliest, current) => {
                    return current.__parsedDate < earliest ? current.__parsedDate : earliest;
                }, datedInterviews[0].__parsedDate);

                const earliestMonth = new Date(earliestDate.getFullYear(), earliestDate.getMonth(), 1);
                const groups = [];
                let cursor = new Date(startMonth.getFullYear(), startMonth.getMonth(), 1);

                while (cursor >= earliestMonth) {
                    const year = cursor.getFullYear();
                    const month = cursor.getMonth();
                    const key = `${year}-${String(month + 1).padStart(2, '0')}`;

                    const rows = datedInterviews
                        .filter(interview => interview.__parsedDate.getFullYear() === year && interview.__parsedDate.getMonth() === month)
                        .sort((a, b) => b.__parsedDate - a.__parsedDate)
                        .map(interview => {
                            const cleanedInterview = { ...interview };
                            delete cleanedInterview.__parsedDate;
                            return cleanedInterview;
                        });

                    groups.push({
                        key,
                        label: cursor.toLocaleString('en-GB', { month: 'long', year: 'numeric' }),
                        rows
                    });

                    cursor = new Date(year, month - 1, 1);
                }

                return groups;
            }
        },
        watch: {
           
        },
        methods: {
            async getInterviews() {
                this.interviews = []
                this.loading=true
                UtilityService.getSimpleApiData(this.accessToken, "member_interviews")
                .then(
                    (interviews => {
                        this.$set(this, "interviews", interviews);
                        this.loading=false;
                        this.working = false;
                    }).bind(this)
                );
               
            },
            parseInterviewDate(dateValue) {
                if (!dateValue) {
                    return null;
                }

                const splitValue = String(dateValue).split('T')[0];
                const parts = splitValue.split('-');

                if (parts.length !== 3) {
                    return null;
                }

                const year = Number(parts[0]);
                const month = Number(parts[1]);
                const day = Number(parts[2]);

                if (!year || !month || !day) {
                    return null;
                }

                return new Date(year, month - 1, day);
            },
            getInterviewMemberName(interview) {
                const forename = interview.forename || (interview.member && interview.member.forename) || '';
                const surname = interview.surname || (interview.member && interview.member.surname) || '';
                return `${forename} ${surname}`.trim();
            },
            getInterviewMemberId(interview) {
                return interview.member_id || (interview.member && interview.member.id) || '';
            },
            getInterviewStatusLabel(statusId) {
                if (statusId == 1) {
                    return 'Arranged';
                }

                if (statusId == 2) {
                    return 'Completed';
                }

                if (statusId == 3) {
                    return 'Cancelled';
                }

                return statusId;
            }
        }
       
    }
</script>